import { Box, Card, CardContent, Typography, Link, Stack } from "@mui/material";
import { useModal } from "../util/modal/useModal.ts";
import { ModalType } from "../types/ModalType.ts";
import { trackEvent } from "../util/analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";

type HeroHeaderProps = {
  title: string;
  description: string;
  backgroundImage?: string;
  showCalculateLink?: boolean;
};

export const HeroHeader = ({
  title,
  description,
  backgroundImage,
  showCalculateLink = false,
}: HeroHeaderProps) => {
  const { openModal } = useModal();
  return (
    <Card
      sx={{
        backgroundColor: "primary.dark",
        padding: 2,
        borderRadius: 2,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {backgroundImage && (
        <Box
          component="img"
          src={backgroundImage}
          alt=""
          sx={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            height: "100%",
            opacity: 0.6,
          }}
        />
      )}
      <CardContent sx={{ position: "relative", zIndex: 1 }}>
        <Stack
          direction={"column"}
          alignItems={"flex-start"}
          gap={1}
          sx={{
            maxWidth: 600,
          }}
        >
          <Typography variant="h4" sx={{ color: "primary.contrastText" }}>
            {title}
          </Typography>
          <Typography variant="body1" sx={{ color: "primary.contrastText" }}>
            {description}
          </Typography>
          {showCalculateLink && (
            <Link
              component="button"
              type={"button"}
              onClick={() => {
                openModal(ModalType.Calculation);
                trackEvent(
                  EventCategory.Plan,
                  "Opened Calculate Modal",
                  window.location.href,
                );
              }}
              sx={{
                color: "primary.contrastText",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              How we calculate your plan
            </Link>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
